(function () {
    'use strict';
    angular.module('Services').service('CarrierProfileTrackingTableService', CarrierProfileTrackingTableService);
    CarrierProfileTrackingTableService.$inject = [
        'TableLiteFactory',
        '$filter',
        '$uibModal'
    ];

    function CarrierProfileTrackingTableService(
        TableLiteFactory,
        $filter,
        $uibModal
        
    ) {
        return function (configData, companies, currency, addSurchargeCallback) {
            const vm = this;
            console.log(configData)
            const tableData = {
                optionAddOns: {
                    buttons:[
                        {
                            class: 'btn-primary',
                            label: 'Add Override URL',
                            tooltip: 'Add Override URL',
                            onClick: function () {
                                const rowData ={
                                    companyId:'',
                                    trackingUrl:'',
                                    disabled: false
                                }
                                tableData.data.push(generateRowData(rowData));
                            }
                        }

                    ]
                },
                config: {
                    tableMinHeight: '200px',
                    noPagination: true,
                    noHeaders: false,
                    noItemView: true,
                    noFooter: true
                },
                headers: [{
                    label: 'Companies',
                    width:'300px',
                    viewName: 'companies',
                    fieldName: 'companies'
                }, {
                    label: 'Override Tracking URL',
                    viewName: 'trackingUrl',
                    fieldName: 'trackingUrl'
                }, {
                    label: 'Actions',
                    viewName: 'action',
                    
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function (callback) {
                    callback({ content: configData });
                },
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: data => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                if (!data) {
                    return tableData;
                }
                tableActions.initializeTableData(data);

                angular.forEach(data.content, row => {
                    tableData.data.push(generateRowData(row));
                });
            }

            function editMode(row){
                
                if(tableData.data[row.index].companies.disabled){
                    tableData.data[row.index].companies.disabled = false;
                    tableData.data[row.index].trackingUrl.disabled = false;
                    return;
                }
                tableData.data[row.index].companies.disabled = true;
                tableData.data[row.index].trackingUrl.disabled = true;
            }

            function generateRowData(data) {
                
                return {
                    companies: {
                        url: '/templates/directives/intellectual-table/body-cells/select2.html',
                        model: companies.content.find(res=>res.id == data.companyId),
                        disabled: data.companyId ? true: false,
                        items: companies.content
                    },
                    trackingUrl: {
                        url: '/templates/directives/intellectual-table/body-cells/textInput.html',
                        value: data.trackingUrl,
                        model: data.trackingUrl,
                        disabled: data.companyId ? true: false,
                        options: {
                            required: true
                        }
                    },
                    
                    action: {
                        type:'button',
                        buttons:[
                            {
                               
                                class:`btn btn-success btn-circle glyphicon ${data.companyId ? ' glyphicon-pencil':' glyphicon-ok'}`,
                                action: row => {
                                    editMode(row)
                                }
                            },
                            {
                               
                                class:'btn btn-danger btn-circle glyphicon glyphicon-trash',
                                action: row => {
                                    tableData.data.splice(row.index,1)
                                }
                            }

                        ]
                    }
                }
            }

            function getTotalSurcharges(sellPrice) {
                let basePrice = Number(sellPrice);
                let surchargeTotal = 0;

                let prevFixValue = 0;
                let prevPercentTotalValue = 0;
                let surchargeRunningValue = basePrice;

                tableData.data.forEach(item => {
                    const fixValue = Number(item.fixedValue.value);
                    const percent = Number(item.percentage.value);
                    surchargeTotal += fixValue;

                    if (percent > 0) {
                        surchargeRunningValue += prevFixValue + prevPercentTotalValue;
                        const percentageValue = ((surchargeRunningValue + fixValue) * percent) / 100;

                        item.percentageValue = percentageValue.toFixed(2);
                        prevFixValue = fixValue;
                        prevPercentTotalValue = percentageValue;
                        surchargeTotal += percentageValue;
                    }
                     else {
                        item.percentageValue = percent.toFixed(2);
                    }
                });

                return {
                    surchargeTotal: math.bignumber(surchargeTotal)
                };
            }

            function getSurchargesDetails() {
                return tableData.data.map(item => {
                    return {
                        fix: Number(item.fixedValue.value),
                        name: item.surchargeName,
                        percent: Number(item.percentage.value),
                        percentAmount: Number(item.percentageValue),
                        totalAmount: Number(item.fixedValue.value) + Number(item.percentageValue)
                    }
                });
            }

            vm.getTrackingConfigPayload = () => {
                let settings = [];
                angular.forEach(tableData.data, function (config) {
                    settings.push({
                        companyId: config.companies.model.id,
                        trackingUrl: config.trackingUrl.model,
                        
                    });
                });
                return settings;
            };


            this.getTotalSurcharges = getTotalSurcharges;
            this.getSurchargesDetails = getSurchargesDetails;
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/CarrierProfileTrackingTableService.js